import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import { Button, Card, Grid, AppBar, Paper, CardContent, Divider, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { TextFieldFormsy, FuseAnimate } from '@fuse';
import Formsy from 'formsy-react';
import { FusePageCarded } from '@fuse';
import * as Actions from '../../../auth/store/actions';
import TabPanelButtons from '../../components/TabPanelButtons';

const styles = theme => ({
    root: {
        backgroundImage: "url(assets/images/backgrounds/header-bg.png)",
        backgroundSize: 'auto',
        height: '100vh'
    },
    paperWrapper: {
        paddingTop: '10vh',
        height: '20vh'
    },
    paperDiv: {
        height: '20vh'
    },
    cardDiv: {
        height: '40%'
    },
    paddingDiv: {
        paddingTop: '10vh'
    },
    instructionsDiv: {
        padding: '15px',
        fontSize: '18px',
    },
    sendButton: {
        paddingLeft: '15px',
        paddingRight: '15px'
    },
    gridStyle: {
        padding: '15px',
    }
});


class PasswordEdit extends Component {

    state = {
        auth_id: 0
    }

    constructor(props) {
        super(props);

        const auth_id = this.props.match.params.auth_id;

        this.state = {
            ...this.state,
            auth_id: auth_id,
        }
    }

    componentWillMount = () => {
        this.props.getAuth(this.state.auth_id);
    }

    onSubmit = (model) => {
        const auth_token = localStorage.getItem('token');
        
        this.props.changePasswordAdmin(model.password, this.state.auth_id, auth_token);
        this.props.history.push('/user/edit/' + this.state.auth_id);
    }

    render() {
        const { classes, currentAuth } = this.props

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <div className="py-24"><h4>{'Change User Password'}</h4></div>
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%', }}>
                        {/* The div below is only for properly pushing the buttons to the right in lieu of tabs. If tabs get added, delete this div. */}
                        <div className="flex items-center justify-end" style={{ height: '64px' }}>
                            <TabPanelButtons
                                component_name = {"user"}
                                view_type      = {'edit'}
                                button_list    = {[
                                    {
                                        type:    "back",
                                        onClick: this.props.history.goBack
                                    }
                                ]}
                            />
                        </div>
                    </div>
                }
                content={
                    <Formsy
                        onValidSubmit={this.onSubmit}
                    >
                        <Grid container spacing={8} className={classes.gridStyle}>
                            <Grid item xs={12}>
                                User Name: {currentAuth.FirstName + " " + currentAuth.LastName}
                            </Grid>
                            <Grid item xs={12}>
                                User Email: {currentAuth.Email}
                            </Grid>
                            <Grid item xs={12}>
                                <TextFieldFormsy
                                    type="password"
                                    name="password"
                                    label="Password"
                                    validations="equalsField:password-confirm"
                                    validationErrors={{
                                        equalsField: 'Passwords do not match'
                                    }}
                                    required
                                    autoComplete='new-password'
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextFieldFormsy
                                    type="password"
                                    name="password-confirm"
                                    label="Confirm Password"
                                    validations="equalsField:password"
                                    validationErrors={{
                                        equalsField: 'Passwords do not match'
                                    }}
                                    required
                                    autoComplete='new-password'
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button
                                    type="submit"
                                    variant="raised"
                                    color="primary"
                                    aria-label="Change Password"
                                >
                                    Change Password
                                </Button>
                            </Grid>
                        </Grid>
                    </Formsy>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAuth:             Actions.getAuth,
        changePasswordAdmin: Actions.changePasswordAdmin,
    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {
        currentAuth: auth.crud.currentAuth,
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordEdit)));


// WEBPACK FOOTER //
// src/main/content/auth/PasswordEdit.js